export default "__VITE_ASSET__L_UnXC3l__"